import { CatTableHeader } from '@blocks-react/components/TableHeader';
import { ChildProps } from '../../types';

export const CVATableHeader = ({ children }: Readonly<ChildProps>) => {
  return <CatTableHeader isFrozen={true}>{children}</CatTableHeader>;
};
